import React, { useEffect, useRef, useState } from "react";
import "../../../styles/empowered.css";

const WhoWeEmpower = () => {
    const pathRef = useRef(null);
    const [dots, setDots] = useState([]);
    var items = [
        {
            title: "Contractors",
            description:
                "Streamline project planning, task management, and compliance tracking while ensuring seamless coordination with teams and stakeholders.",
        },
        {
            title: "Sub Contractors",
            description:
                "Enhance efficiency with real-time task assignments, progress tracking, and integrated communication tools to keep projects on schedule.",
        },
        {
            title: "Consultants",
            description:
                "Enhance efficiency with real-time task assignments, progress tracking, and integrated communication tools to keep projects on schedule.",
        },
        {
            title: "Project Owners & Developers",
            description:
                "Gain complete project oversight with financial tracking, compliance monitoring, and data-driven insights to ensure successful project execution.",
        },
    ];
    useEffect(() => {
        if (!pathRef.current) return;

        const path = pathRef.current;
        const pathLength = path.getTotalLength();
        const dotSpacing = 40; // Distance between dots
        let newDots = [];

        for (let i = 0; i < pathLength; i += dotSpacing) {
            const { x, y } = path.getPointAtLength(i);
            newDots.push({ x, y });
        }

        setDots([newDots[2], newDots[11], newDots[19], newDots[27]]);
        console.log("dots on the curve :", newDots);
    }, []);
    return (
        <section id="empower">
            <div className="text-center">
                <h2 className="h1-48-800">
                    Powering<span> Architecture<br /> Engineering <br /> & <br /> Construction</span>
                </h2>
                <p className="subtitle">
                    Tailored Solutions for the Construction Industry
                </p>

                <div className="flex items-center justify-center h-[800px] w-full bg-gray-100 overflow-visible">
                    {/* SVG Curved Line */}
                    <svg
                        width="1224"
                        height="395"
                        viewBox="0 0 1224 395"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{ overflow: "visible" }}
                    >
                        <path
                            ref={pathRef}
                            d="M2 314C86.5 357.5 217 410 330 375C440.5 350 507.5 253 725 255C943.5 257 973 61 1222 2"
                            stroke="var(--color-accent)"
                            strokeWidth="5"
                            fill="none"
                        />
                        {/* Grey Dots */}
                        {dots.map((dot, index) => (
                            <g key={index}>
                                <circle key={index} cx={dot.x} cy={dot.y} r="12" fill="var(--color-primary)" />
                                <foreignObject
                                    x={dot.x - 150} // Adjust x to better center the content
                                    y={dot.y + (index % 2 === 0 ? 40 : -250)}
                                    width="300" // Increased width to accommodate index and text
                                    height="220"
                                >
                                    <div
                                        style={{
                                            display: "flex", // Use flexbox for layout
                                            alignItems: "flex-start", // Align items to the top
                                            position: "relative", // Needed for z-index to work as expected
                                        }}
                                    >
                                        <div
                                            style={{
                                                fontSize: "150px",
                                                fontWeight: "600",
                                                color: "rgba(24, 24, 24, 0.1)",
                                                marginRight: "10px", // Add some space between the index and the text
                                                lineHeight: "1", // Adjust line height to better align with text
                                            }}
                                        >
                                            {index + 1}
                                        </div>
                                        <div
                                            style={{
                                                display: "flex",
                                                flexDirection: "column",
                                                textAlign: "left",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    fontWeight: "800",
                                                    color: "var(--color-text-primary)",
                                                    marginBottom: "4px",
                                                }}
                                            >
                                                {items[index].title}
                                            </div>
                                            <div
                                                style={{
                                                    fontSize: "16px",
                                                    fontWeight: "500",
                                                    color: "#64607D",
                                                }}
                                            >
                                                {items[index].description}
                                            </div>
                                        </div>
                                    </div>
                                </foreignObject>
                            </g>
                        ))}
                    </svg>
                </div>
            </div>
        </section>
    );
};

export default WhoWeEmpower;
